export const shiftArray = (
  arr: Array<string>,
  maxLength: number
): Array<string> => {
  if (arr.length > maxLength) {
    arr.shift();
  }
  return arr;
};
